import React from 'react';

import { ArchivalAidMetadata, ArchivalUnitCopy } from 'types';
import { ApiRoute, GridBodyType, PageKey, SortOrder, UrlRoute } from 'enums';
import { GridEntityConfig } from 'components/grid/grid-types';
import { Grid } from 'components/grid/grid';

import { ArchivalUnitDetail } from './archival-unit-detail';
import { ArchivalUnitQuote } from '../archival-unit/archival-unit-quote';
import { actionButtonsFactory } from 'components/grid/right-panel/action-buttons-factory';

export const archivalUnitConfig: GridEntityConfig<
  ArchivalAidMetadata,
  ArchivalUnitCopy
> = {
  id: 'soukrome-archivalie',
  title: 'Archiválie (soukromá)',
  getLabel: (item) => `Archiválie (soukromá) - ${item.numericId?.toString()}`,
  getId: (item) => item.id,
  urlRoute: UrlRoute.ARCHIVAL_UNIT_PRIVATE,
  apiRoute: ApiRoute.ARCHIVAL_UNIT_PRIVATE,
  listApi: '/api/archival-unit/private/list',
  pageKey: PageKey.DETAIL_ARCHIVAL_UNIT_PRIVATE,
  ActionButtons: actionButtonsFactory([
    { id: 'download', label: 'Stáhnout metadata/popis' },
    { id: 'quote', Component: ArchivalUnitQuote },
  ]),
  icon: 'description',
  bodyComponents: { [GridBodyType.DETAIL]: ArchivalUnitDetail },
  params: {
    sort: [{ field: 'numericId', order: SortOrder.ASC }],
    filters: [{ field: 'metadataOnly', operation: 'EQ', value: 'false' }],
  },
};

export const archivalUnitGridConfig: any[] = [archivalUnitConfig];

export const ArchivalUnitPublicGrid = () => (
  <Grid
    gridConfig={archivalUnitGridConfig}
    leftPanelProps={{ hide: true }}
    centralPanelProps={{ hideTransitionButtons: true }}
  />
);
